<div
  (click)="onCLick()"
  class="flex justify-center w-8 rounded p-1 cursor-pointer"
  [ngClass]="title != 'terminal' ? 'hover:bg-red-light' : ''"
>
  @if (isTitleType(title)) {
    <img [ngSrc]="`/icons/${title}.svg`" alt="Excluir" width="150" height="150" />
  } @else {
    <app-button>{{ capitalize(title) }}</app-button>
  }
</div>
